import { Component, Vue } from 'vue-property-decorator'
import { getAllocationClassList, queryAllTeacher, queryAllTa, setTeacherAndTa, queryIpqSupervisorCommon } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'
@Component({ name: 'allocation-list-page', components: { HighFilter } })
export default class AllocationListPage extends Vue {
  private actionDialogVisible = false // 分配弹窗
  private changeDialogVisible = false // 修改弹窗 Teacher
  private changeTADialogVisible = false // 修改TA
  private dataType = 1 // 1 - 待分配 2 - 已分配
  private totalPage = 1;
  private currentPage = 1;
  private teacherList: any = []
  private taList: any = []
  private supervisorList: any = []
  private chooseData: any = {}
  private isGroup = false
  private multipleSelection = []
  private selectData: any = {
    ta: null,
    teacher: null,
    supervisorId: null
  }

  private showHighFilter = false
  private filterData: any = {}
  private filterResult: any = null
  private filterTypeChoose = null;

  private tableData = []
  private tableloading: any = false

  created () {
    this.initPageData()
  }

  private async initPageData () {
    this.tableloading = true
    const param: any = { haveDirector: this.dataType === 2, page: this.currentPage, limit: 20 }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getAllocationClassList(param)
    const { allPage, currentPage, classList } = result
    this.filterData = result.search
    this.teacherList = await queryAllTeacher({})
    this.taList = await queryAllTa({})
    this.supervisorList = await queryIpqSupervisorCommon({})
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = classList
    this.tableloading = false
  }

  /**
   * [description] 分页切换回调函数
   */
  private onPageChange () {
    this.initPageData()
  }

  /**
   * [description] 分配按钮点击
   */
  private async onActionClick (data: any) {
    this.selectData.ta = null
    this.selectData.teacher = null
    this.selectData.supervisorId = null
    this.chooseData = data
    this.actionDialogVisible = true
  }

  private onTypeChange (type: any) {
    if (!this.tableloading) {
      this.dataType = type
      this.tableData = []
      // 切换以后 需要把当前页标记归位
      this.currentPage = 1
      this.filterResult = null
      this.initPageData()
    }
  }

  /**
   * [description] 修改班主任点击
   */
  private async onSetTeacher (data: any) {
    this.teacherList = await queryAllTeacher({})
    this.selectData.ta = null
    this.selectData.teacher = null
    this.selectData.supervisorId = null
    this.chooseData = data
    this.changeDialogVisible = true
  }

  /**
   * [description] 批量分配老师的按钮点击
   */
  private async onGroupAllocationClick () {
    this.isGroup = true
    this.teacherList = await queryAllTeacher({})
    this.taList = await queryAllTa({})
    this.selectData.ta = null
    this.selectData.teacher = null
    this.selectData.supervisorId = null
    this.actionDialogVisible = true
  }

  // 批量修改
  private async onGroupChangeClick () {
    this.isGroup = true
    this.teacherList = await queryAllTeacher({})
    this.taList = await queryAllTa({})
    this.selectData.ta = null
    this.selectData.teacher = null
    this.selectData.supervisorId = null
    this.actionDialogVisible = true
    // this.$confirm('不是同一位班主任，不能进行批量修改', '提示', { type: 'warning', showCancelButton: false, showConfirmButton: false })
  }

  private handleSelectionChange (val: any) {
    this.multipleSelection = val.map((item: any) => { return item.classId })
  }

  /**
   * [description] 点击
   */
  private async onJoinClick () {
    const param: any = { }
    if (this.isGroup) {
      param.classId = this.multipleSelection
    } else {
      param.classId = [this.chooseData.classId]
    }
    if (this.selectData.teacher !== null) param.directorId = this.selectData.teacher
    if (!this.isGroup) {
      // 分配ta
      if (this.chooseData.courseTypeId !== 30 && this.selectData.ta !== null && this.selectData.ta.length > 0) {
        param.TAId = this.selectData.ta
      }
      // 分配supervisor
      if (this.chooseData.courseTypeId === 30 && this.selectData.supervisorId !== null && this.selectData.supervisorId.length > 0) {
        param.supervisorId = this.selectData.supervisorId
      }
    }
    await setTeacherAndTa(param)
    this.actionDialogVisible = false
    this.initPageData()
    this.chooseData = {}
    this.selectData.ta = null
    this.selectData.teacher = null
    this.selectData.supervisorId = null
    this.isGroup = false
  }

  /**
   * [description] 修改班主任的弹窗 确认按钮回调函数
   */
  private async onChangeClick () {
    const param: any = {}
    if (this.isGroup) {
      param.classId = this.multipleSelection
    } else {
      param.classId = [this.chooseData.classId]
    }
    if (this.selectData.teacher !== null) param.directorId = this.selectData.teacher
    if (!this.isGroup) {
      if (this.chooseData.courseTypeId !== 30 && this.selectData.ta !== null && this.selectData.ta.length > 0) {
        param.TAId = this.selectData.ta
      }
      if (this.chooseData.courseTypeId === 30 && this.selectData.supervisorId !== null && this.selectData.supervisorId.length > 0) {
        param.supervisorId = this.selectData.supervisorId
      }
    }
    await setTeacherAndTa(param)
    this.changeDialogVisible = false
    this.changeTADialogVisible = false
    this.initPageData()
    this.chooseData = {}
    this.selectData.ta = null
    this.selectData.teacher = null
    this.isGroup = false
  }

  private onSetTA (item: any) {
    this.changeTADialogVisible = true
    this.chooseData = item
  }

  /**
   * [description] 判断是不是小组课
   */
  private isPbl (item: any) {
    const typeId = item.courseTypeId
    return (typeId === 1 || typeId === 6)
  }

  /**
   * [description] 判断是不是1v1课程
   */
  private is1v1 (item: any) {
    const typeId = item.courseTypeId
    return (typeId === 2 || typeId === 3)
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initPageData()
    this.showHighFilter = false
  }
}
